import {debounce} from 'lodash'
import {useEffect, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import Paginator from '../../../custom/Paginator'
import Loader from '../../../custom/loader/Loader'
import {Dropdown, DropdownButton} from 'react-bootstrap'
import {useAppDispatch} from '../../../../redux/hooks'
import {GetStduentUsers, deleteUser} from '../../../../redux/Slice/userSlice'
import {StartImpersonate} from '../../../../redux/Slice/generalSlice'
import {encryptId} from '../../../../_metronic/helpers/Encrypt'
import NoData from '_metronic/helpers/NoData'
import {showConfirmation, showErrorMessage, showSuccessMessage} from '_metronic/helpers/swalHelper'
import {useAuth} from '../core/Auth'
import {getUserByToken} from '../core/_requests'
import CustomSelect from 'app/custom/CustomSelect'
import {RecordsNo} from '_metronic/helpers/jsonData'

const SORT_ASC = 'asc'
const SORT_DESC = 'desc'

const StudentUserDataTable = (props: any) => {
  const [data, setData] = useState([])
  const [perPage, setPerPage] = useState(50)
  const [sortColumn, setSortColumn] = useState(props.columns[0])
  const [sortOrder, setSortOrder] = useState('asc')
  const [search, setSearch] = useState('')
  const [email, setEmail] = useState('')
  const [username, setUsername] = useState('')
  const [pagination, setPagination] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const {t} = useTranslation()

  const dispatch = useAppDispatch()

  const {saveAuth, setCurrentUser, currentUser, hasPermission} = useAuth()

  const handleSort = (column: any) => {
    if (column === sortColumn) {
      sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC)
    } else {
      setSortColumn(column)
      setSortOrder(SORT_ASC)
    }
  }

  const handleSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setSearch(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current
  const handleEmailSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setEmail(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current
  const handleUsernameSearch = useRef(
    debounce((query) => {
      setLoading(true)
      setUsername(query)
      setCurrentPage(1)
      setSortOrder(SORT_ASC)
      setSortColumn(props.columns[0])
    }, 500)
  ).current

  // Global params for pagination
  const params = {
    search,
    email,
    username,
    sort_field: sortColumn,
    sort_order: sortOrder,
    per_page: perPage,
    page: currentPage,
  }
  const listData = () => {
    dispatch(GetStduentUsers({params})).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setData(res.payload.data)
        setPagination(res.payload.meta)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    listData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, email, perPage, search, username, sortColumn, sortOrder])

  const handleDelete = (id: any) => {
    showConfirmation(
      t('MESSAGES.CONFIRMATION'),
      t('GLOBAL.YES'),
      t('GLOBAL.NO'),
      () => {
        setLoading(true)
        dispatch(deleteUser(id)).then((res) => {
          if (res.meta.requestStatus === 'fulfilled') {
            showSuccessMessage(t('MESSAGES.DELETED'), () => {
              listData()
            })
          }
        })
      },
      () => showErrorMessage(t('MESSAGES.SERVER_ERROR'))
    )
  }

  const handleImpersonate = async (id: any) => {
    setLoading(true)
    sessionStorage.setItem('impersonator_id', encryptId(currentUser?.id))
    const formData = new FormData()
    formData.append('user_id', encryptId(id))
    formData.append('type', 'user')
    const res = await dispatch(StartImpersonate(formData))

    if (res.meta.requestStatus === 'fulfilled') {
      saveAuth(res.payload)
      const {data: user} = await getUserByToken(res.payload.api_token)
      setCurrentUser(user)
      setLoading(false)
      window.location.href = `/dashboard`
    } else {
      showErrorMessage(t('MESSAGES.SERVER_ERROR'))
    }
  }

  return (
    <>
      <div className='row mb-5'>
        <h5>{t('GLOBAL.SEARCH')}</h5>
        <div className='col-3'>
          <input
            type='search'
            placeholder={t('GLOBAL.USERNAME')}
            className={'form-control form-control-sm'}
            onChange={(e) => handleUsernameSearch(e.target.value)}
          />
        </div>
        <div className='col-3'>
          <input
            type='search'
            placeholder={t('GLOBAL.NAME')}
            className={'form-control form-control-sm'}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div className='col-3'>
          <input
            type='search'
            placeholder={t('PROFILE.EMAIL')}
            className={'form-control form-control-sm'}
            onChange={(e) => handleEmailSearch(e.target.value)}
          />
        </div>
        <div className='col-3'>
          <CustomSelect
            className='input'
            onChange={(e: any) => {
              setLoading(true)
              setCurrentPage(1)
              setPerPage(e.id)
            }}
            options={RecordsNo}
            value={perPage}
            placeholderText={t('GLOBAL.RECORD_PER_PAGE')}
          />
        </div>
      </div>

      {/* Search per page ends  */}
      <table className='table table-bordered table-hover align-middle'>
        <thead className='table-secondary'>
          <tr>
            {props.headers.map((header: any) => {
              return (
                <th key={header.headerName} onClick={(e) => handleSort(header.sort)}>
                  {header.headerName.replace('_', ' ')}
                  {header.sort === sortColumn ? (
                    <span>
                      {sortOrder === SORT_ASC ? (
                        <i className='ms-1 fa fa-arrow-up' aria-hidden='true'></i>
                      ) : (
                        <i className='ms-1 fa fa-arrow-down' aria-hidden='true'></i>
                      )}
                    </span>
                  ) : null}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {data?.length === 0 && !loading ? <NoData Colspan={props.columns.length + 1} /> : ''}

          {!loading ? (
            data.map((user: any) => {
              return (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td className='text-center'>
                    <DropdownButton size='sm' title=''>
                      <Dropdown.Item
                        as='button'
                        onClick={() => handleImpersonate(user.id)}
                        className='text-end text-success'
                      >
                        <span className='fa fa-sign-in mx-2' />
                        {t('BUTTONS.Login_', {name: user.name})}
                      </Dropdown.Item>
                      {hasPermission('user-delete') && (
                        <Dropdown.Item
                          as='button'
                          onClick={() => handleDelete(user.id)}
                          disabled={currentUser?.id === user.id}
                          className='text-end text-danger'
                        >
                          <span className='fa fa-trash mx-2' />
                          {t('BUTTONS.DELETE')}
                        </Dropdown.Item>
                      )}
                    </DropdownButton>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={props.columns.length + 1}>
                <div className='d-flex justify-content-center'>{loading && <Loader />}</div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {data?.length > 0 && !loading ? (
        <div className='mt-2' style={{direction: 'ltr'}}>
          <Paginator
            pagination={pagination}
            pageChanged={(page: number) => setCurrentPage(page)}
            totalItems={data.length}
            records_name={t('MENU.STUDENT_USERS')}
          />
        </div>
      ) : null}
    </>
  )
}

export default StudentUserDataTable
